<template>
   <div class="inviter">
    <img class="inviter-image" :src="userInfo.head_image || userImgUrl">
    <div class="inviter-nickname" :style="textColor">{{ userInfo.nickname || '蔚来用户' }}</div>
    <div class="inviter-text" :style="textColor" v-if="invitationText">{{ invitationText }}</div>
   </div>
</template>

<script>
import userImgUrl from '../../../../assets/images/user@2x.png';
export default {
    props: {
        account: {
            type: Object,
            default: () => {
                return {
                    user: '',
                    nickname: ''
                };
            }
        },
        invitationText: {
            type: String,
            default: ''
        },
        textStyle: {
            type: Object,
            default: () => ({
                textColor: '#050B27'
            })
        }
    },
    methods: {},
    computed: {
        userInfo() {
            if (this.account.user) {
                return this.account.user;
            }
            return this.account;
        },
        userImgUrl() {
            return userImgUrl;
        },
        textColor() {
            return { color: this.textStyle.textColor };
        }
    },
    components: {}
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/variable.less';
.inviter {
    font-size: 16 * @layout375;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-image {
        width: 55 * @layout375;
        height: 55 * @layout375;
        border-radius: 50%;
        border: 1px solid #FFFFFF;
    }
    &-nickname {
        margin-top: 10 * @layout375;
    }
    &-text {
        margin-top: 10 * @layout375;
        text-align: center;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/marketing/components/leads-award/inviter-info.vue